import { Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core';
import { POINTER_EVENTS, PointerEvent } from '../../../../../models/pointers.types';
import { Target, TARGETS } from '../../../../../models/targets.types';

@Component({
  tag: 'wink-navigation-list-item',
  styleUrl: 'styles/navigation-list-item.default.scss',
  shadow: true,
})
export class NavigationListItem {
  @Element() host!: HTMLWinkNavigationListItemElement;

  @Prop() href = '';
  @Prop() target: Target = TARGETS.self;
  @Prop() pointerEvent: PointerEvent = POINTER_EVENTS.auto;

  @Event() navigationListItemClicked!: EventEmitter<string>;

  private onClick(event: MouseEvent) {
    if (this.pointerEvent === POINTER_EVENTS.none) {
      event.preventDefault();
      return;
    }
    this.navigationListItemClicked.emit(this.href);
  }

  render() {
    return (
      <Host role="listitem">
        <a
          class="navigation-list-item"
          href={this.href}
          target={this.target}
          tabindex={this.pointerEvent === POINTER_EVENTS.none ? -1 : 0}
          onClick={(event) => this.onClick(event)}>
          <slot />
        </a>
      </Host>
    );
  }
}
